import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Graffiti = () => {

  return (
    <StyledGallery>
      <div>
        <figure>
          <div>
            <StaticImage
              src="../../../images/mabani/graffiti-on-cell-walls-in-al-mabani.jpg"
              alt="Graffiti on cell walls in Al Mabani migrant prison"
            />
          </div>
          <figcaption>Graffiti on the walls of Libya&rsquo;s migrant prisons.</figcaption>
        </figure>

        <figure>
          <StaticImage
            src="../../../images/mabani/graffiti-3.jpg"
            alt="Graffiti on cell walls in Al Mabani migrant prison"
          />
        </figure>
        <figure>
          <StaticImage
            src="../../../images/mabani/graffiti-2.jpg"
            alt="Graffiti on cell walls in Al Mabani migrant prison"
          />
        </figure>
      </div>
    </StyledGallery>
  );
};

export default Graffiti;

const StyledGallery = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  > div {
    position: relative;
    margin: 0 auto;
    max-width: 80em;
  }
  figure {
    margin: calc(2 * var(--text-size)) 0;
  }
  figure:nth-of-type(2),
  figure:nth-of-type(3) {
    display: none;
  }
  figcaption {
    font-size: var(--text-size-large);
    font-family: var(--font-serif);
    line-height: 1.4;
    margin: 0.5em 0;
    text-align: center;
  }

  @media ( min-width: 48em ) {
    padding: 0 calc(2 * var(--text-size));
    figure:first-of-type {
      display: grid;
      grid-template: 1fr / 1.5fr 1fr;
      grid-gap: var(--gutter);
      align-items: center;
      margin: calc(3 * var(--text-size)) 0;
      max-width: 70em;
      &:not(:first-of-type) {
        margin-top: calc(4 * var(--text-size));
      }
      &:nth-of-type(odd) {
        margin-left: 10%;
      }
      &:nth-of-type(even) {
        grid-template: 1fr / 1fr 1.5fr;
        margin-right: 10%;
        > figcaption {
          grid-row: 1;
          grid-column: 1;
          text-align: right;
        }
      }
    }
    figcaption {
      font-size: calc(1.5 * var(--text-size));
      text-align: left;
      margin: 1.5em 0 0;
    }
    figure:nth-of-type(2),
    figure:nth-of-type(3) {
      position: absolute;
      display: block;
      right: calc( -0.5 * var(--gutter));
      width: calc(((100vw - (var(--text-max-width)))/2) - calc( 3 * var(--gutter)));
      max-width: 20em;
    }
    figure:nth-of-type(2) {
      bottom: 100%;
    }
    figure:nth-of-type(3) {
      top: 100%;
    }
  }

`
